var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShakeHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.12 10.89l3.31 3.32a2.13 2.13 0 003.06.2L21.9 13M11.64 4.86a2 2 0 00-2.36-.35L4.93 6.64H2.1M2.81 3.81V18M21.19 3.81V18",
    stroke: "#38e5e2",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13 9.47a2 2 0 00-2.83 0 1 1 0 01-1.42 0l-.7-.71 3.19-3.19a1 1 0 011.21-.15L18 7.58V5.35l-3.5-1.71a3 3 0 00-3.5.52l-4.6 4.6 2.12 2.12a3 3 0 004.24 0L17 15.13a1 1 0 01.3.69 1 1 0 01-.29.69l-2.83 2.78a1 1 0 01-1.42 0L6 14.75v2.4l5.36 3.63a3 3 0 004.16-.07l2.84-2.77a3 3 0 00.88-2.12 3 3 0 00-.88-2.11l-4.23-4.24z",
    fill: "#38e5e2",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShakeHands);
export default __webpack_public_path__ + "static/media/shake-hands.b0ef31b1f19551c46cab526ef6339f93.svg";
export { ForwardRef as ReactComponent };